<template>
  <div class="washCar" ref="washCar">
    <div class="washCarBg"></div>
    <div class="content" @click="goToPopup()">
      <div class="left">
        <div class="left_car">
          <div class="img1"></div>
          <div class="img3"></div>
        </div>
        <div class="left_num">
          <div class="left_allCount">
            <span class="number">{{
              resData.carWasherCount ? resData.carWasherCount : 0
            }}</span
            >台
          </div>
          <div v-if="customerId === 66" class="left_text">洗车台总数</div>
          <div v-else class="left_text">洗车机总数</div>
        </div>
      </div>
      <div class="right">
        <div class="block">
          <p>
            <span style="color: #4be0ff">今日</span>洗车
            <span class="number">
              {{ resData.dayCount ? resData.dayCount : 0 }} </span
            >次
          </p>
        </div>
        <div class="block">
          <p>
            <span style="color: #4be0ff">本周</span>洗车
            <span class="number">{{
              resData.weekCount ? resData.weekCount : 0
            }}</span
            >次
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from "vuex";
import iframePup from "@/modules/iframePup/iframePup.vue";
import { getEncryptWithPassword } from "@/utils/cryptoUtil.js";
import mybus from "../../../../../utils/eventbus.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      options: [],
      value: "",
      resData: {},
      type: "",
      num: 0,
      setTime1: null,
      timeTimer: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.washCar).outerWidth();
    let h = $(that.$refs.washCar).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
    this.timeTimer = setInterval(() => {
      this.getData();
    }, 1000 * 10);
    this.setIntroduction();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
    if (this.timeTimer) {
      clearInterval(this.timeTimer);
      this.timeTimer = null;
    }
  },
  //方法集合
  methods: {
    async getData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      let data;
      let findCarWashCount = CONFIG.requestName + this.$apiOpt.findCarWashCount;
      // try {
      data = await this.$apiUtils.get(findCarWashCount, {
        customerId: this.customerId,
      });
      if (data && (data.carWasherCount || data.dayCount || data.weekCount)) {
        this.resData = data;
        // this.setTime1 = setTimeout(() => {
        //   this.getData();
        // }, 1000 * 5 * 60);
      } else {
        // this.setTime1 = setTimeout(() => {
        //   this.getData();
        // }, 1000 * 30);
        this.resData = {};
      }
    },
    async goToPopup() {
      this.$store.commit("dialogStatus", true);
      let url;
      if (this.customerId == 47) {
        url =
          `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
          (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
      } else if (this.customerId == 64) {
        url =
          `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
          (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
      } else {
        url =
          `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
          (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        if (this.customerId == 39) {
          url =
            `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
            (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        }
        if (this.customerId == 108) {
          url =
            `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
            (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        }
        if (this.customerId == 48) {
          url =
            `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
            (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        }
        if (this.customerId == 77) {
          url =
            `http://vis.bmetech.com/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` +
            (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        }
        if (this.customerId == 15) {
          url = `http://10.3.34.59:4046/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}`;
        }
      }
      this.pageTitleName = "洗车机动态";
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: url,
      });
    },
    setIntroduction() {
      mybus.$on("showWashCarData", (isOpen) => {
        if (isOpen) {
          this.goToPopup();
        } else {
          this.$store.commit("dialogStatus", false);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.washCar {
  width: 600px;
  height: 250px;
  .washCarBg {
    position: absolute;
    top: 52px;
    z-index: -1;
    @include bg-box(560px, 178px, "washCarBg.png");
  }
  .content {
    display: flex;
    width: 100%;
    height: 100%;
    padding-top: 35px;
    cursor: pointer;
    .left {
      width: 244px;
      position: relative;
      margin-right: 20px;
      display: flex;
      .left_car {
        width: 50%;
        height: 100%;
        position: relative;
        div {
          position: absolute;
        }
        .img1 {
          top: 18px;
          left: 26px;
          @include bg-box(70px, 67px, "arrow.png");
          animation: shake 1s ease infinite alternate;
        }
        .img3 {
          top: 89px;
          left: 15px;
          @include bg-box(86px, 56px, "door.png");
        }
        @keyframes shake {
          0% {
            top: 18px;
          }
          100% {
            top: 10px;
          }
        }
      }
      .left_num {
        width: 50%;
        padding-top: 56px;
        .left_allCount {
          height: 48px;
          font-size: 16px;
          color: #ffffff;
          line-height: 16px;
          span {
            width: 52px;
            margin-right: 15px;
            height: 48px;
            font-size: 48px;
            color: #65f5f2;
            line-height: 48px;
            text-shadow: 0px 2px 6px #0091ff;
          }
        }
        .left_text {
          height: 28px;
          font-size: 20px;
          color: #f7b500;
          line-height: 28px;
          margin-top: 16px;
        }
      }
    }
    .right {
      width: 299px;
      text-align: center;
      padding: 0px 11px 0px 30px;
      .block {
        height: 40%;
        padding-top: 20px;
        border-bottom: 1px solid;
        border-image: linear-gradient(
            90deg,
            rgba(169, 200, 251, 1),
            rgba(113, 152, 246, 0)
          )
          1 1;
        p {
          font-size: 18px;
          color: #9bc0f0;
          .number {
            font-size: 45px;
            font-weight: 500;
            color: #65f5f2;
            margin-left: 21px;
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
